import { CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabLandingPage } from './tab-landing.page';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TabLandingPageRoutingModule } from './tab-landing-routing.module';



@NgModule({
  declarations: [TabLandingPage],
  imports: [
    IonicModule,
    FormsModule,
    CommonModule,
    TabLandingPageRoutingModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class TabLandingPageModule {}
